import { UserPermissions } from '@agroone/entities'
import { DestroyRef, Directive, TemplateRef, ViewContainerRef, inject, input } from '@angular/core'
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop'
import { combineLatest } from 'rxjs'
import { ConnectionService } from '../services/connection.service'
import { SharedPermissionService } from '../services/shared-permission.service'

@Directive({
  selector: '[isGranted]',
})
export class IsGrantedDirective {
  private readonly destroyRef = inject(DestroyRef)

  private _connectionService = inject(ConnectionService)
  private _permissionService = inject(SharedPermissionService)
  private _templateRef = inject(TemplateRef<HTMLElement>)
  private _viewContainer = inject(ViewContainerRef)

  readonly isGranted = input.required<UserPermissions[]>()

  constructor() {
    combineLatest([toObservable(this.isGranted), this._connectionService.connection$])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([permissions, isConnected]) => {
        this._viewContainer.clear()
        if (this._permissionService.isGranted(permissions, isConnected)) {
          this._viewContainer.createEmbeddedView(this._templateRef)
        }
      })
  }
}
